import React from 'react';
import { ratingMeta, RATING_META, fmtDate } from './groupMeta';

// Small SVG line chart of rating history (oldest → newest)
export const RatingTrend = ({ inspections }) => {
  const pts = [...inspections].reverse().slice(-12);
  if (pts.length < 2) return <p className="text-xs text-white/35 py-6 text-center">Two or more inspections needed to show a trend.</p>;
  const W = 520, H = 150, P = 24;
  const x = (i) => P + (i * (W - P * 2)) / (pts.length - 1);
  const y = (r) => H - P - ((ratingMeta(r).score ?? 0) * (H - P * 2)) / 4;
  const d = pts.map((p, i) => `${i ? 'L' : 'M'}${x(i)},${y(p.rating)}`).join(' ');
  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-auto" data-testid="rating-trend-chart">
      <defs>
        <linearGradient id="trendFill" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor="#00E5FF" stopOpacity="0.25" /><stop offset="100%" stopColor="#00E5FF" stopOpacity="0" />
        </linearGradient>
      </defs>
      {Object.entries(RATING_META).map(([k, m]) => (
        <g key={k}>
          <line x1={P} x2={W - P} y1={y(k)} y2={y(k)} stroke="rgba(255,255,255,0.05)" strokeDasharray="3 4" />
          <text x={W - P + 4} y={y(k) + 3} fontSize="8" fill={m.hex} opacity="0.7">{m.short}</text>
        </g>
      ))}
      <path d={`${d} L${x(pts.length - 1)},${H - P} L${x(0)},${H - P} Z`} fill="url(#trendFill)" />
      <path d={d} fill="none" stroke="#00E5FF" strokeWidth="2" strokeLinejoin="round" />
      {pts.map((p, i) => (
        <g key={p.id}>
          <circle cx={x(i)} cy={y(p.rating)} r="4.5" fill="#0a0a14" stroke={ratingMeta(p.rating).hex} strokeWidth="2.5" />
          <title>{`${fmtDate(p.date)} — ${ratingMeta(p.rating).label}`}</title>
        </g>
      ))}
    </svg>
  );
};
